module.exports = __webpack_public_path__ + "static/media/Screenshot_60.80388299.png";